// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.manage-groups-main{
    padding: 13px 0px 20px;
    height: calc(100vh - 73px);
    overflow-y: hidden;
}

 .stop-btn{
    background-color: var(--main-color);
    border: none;
    border-radius:22px ;
    padding: 10px 22px;
    color: white;
    font-weight: bold;
    margin-top: 10px;
    cursor: pointer;
}

.stop-btn:hover{
    opacity: .9;
}

.manage-groups-main .download-btn{
    background-color: transparent;
    border: none;
    color: gray;
    margin: 6px 10px 0px;
    cursor: pointer;
    transition: var(--main-transition);
    border-radius: 50%;
    padding: 1px 12px;

} 

.manage-groups-main .download-btn:hover{
    background-color: #d0d0d0;

}`, "",{"version":3,"sources":["webpack://./src/Pages/ManageGrousp/managegroups.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,0BAA0B;IAC1B,kBAAkB;AACtB;;CAEC;IACG,mCAAmC;IACnC,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,WAAW;IACX,oBAAoB;IACpB,eAAe;IACf,kCAAkC;IAClC,kBAAkB;IAClB,iBAAiB;;AAErB;;AAEA;IACI,yBAAyB;;AAE7B","sourcesContent":[".manage-groups-main{\n    padding: 13px 0px 20px;\n    height: calc(100vh - 73px);\n    overflow-y: hidden;\n}\n\n .stop-btn{\n    background-color: var(--main-color);\n    border: none;\n    border-radius:22px ;\n    padding: 10px 22px;\n    color: white;\n    font-weight: bold;\n    margin-top: 10px;\n    cursor: pointer;\n}\n\n.stop-btn:hover{\n    opacity: .9;\n}\n\n.manage-groups-main .download-btn{\n    background-color: transparent;\n    border: none;\n    color: gray;\n    margin: 6px 10px 0px;\n    cursor: pointer;\n    transition: var(--main-transition);\n    border-radius: 50%;\n    padding: 1px 12px;\n\n} \n\n.manage-groups-main .download-btn:hover{\n    background-color: #d0d0d0;\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
